import { useEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import moment from "moment"
import * as customerApis from "../../utilities/apis/customer"
import Layout from "../../components/Layout"
import Pagination from "../../components/Pagination"

const Customers = () => {
  const navigate = useNavigate()
  const { token, user, permissions } = useSelector(state => state.user)
  const [customers, setCustomers] = useState([])
  const [active, setActive] = useState(1)
  const [count, setCount] = useState(0)
  const mobileRef = useRef(null)
  const [filters, setFilters] = useState({
    offset: 0,
    limit: 10,
  })

  const handleSearch = () => {
    const where = {}

    if (mobileRef.current.value) where.mobile = mobileRef.current.value

    setFilters({ ...filters, offset: 0, ...where })
    setActive(1)
  }

  const handleReset = () => {
    setFilters({ limit: 10, offset: 0 })
    mobileRef.current.value = ''
    setActive(1)
  }

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete?")) return

      const response = await customerApis.deleteCustomer(token, id)
      if (!response.status) throw new Error(response.message)

      setCustomers((previous) => {
        const customers = previous.filter(x => x.id !== id)
        return [...customers]
      })
    } catch (error) {
      alert(error.message)
    }
  }

  const getCustomers = async () => {
    try {
      const query = new URLSearchParams(filters)
      const response = await customerApis.getCustomers(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setCount(response.count)
      setCustomers(response.customers)
    } catch (error) {
      alert(error.message)
    }
  }

  const handlePageChange = (page, offset) => {
    setFilters({ ...filters, offset })
    setActive(page)
  }

  useEffect(() => {
    getCustomers()
  }, [])

  useEffect(() => {
    getCustomers(filters)
  }, [filters])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="w-75 mx-auto">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Customers</p>
            <div className="d-flex gap-2">
              {permissions["READ_CUSTOMERS"] && <button className="btn btn-secondary rounded-4">Export</button>}
              {permissions["CREATE_CUSTOMER"] && <Link to="/dashboard/customer" className="btn btn-theme rounded-4">New</Link>}
            </div>
          </div>

          <div class="border rounded-4 mb-3">
            <div className="p-3 border-bottom rounded-top-4 bg-secondary">
              <div className="row">
                <div className="col-md-2">
                  <input ref={mobileRef} type="text" className="form-control form-control-sm rounded-3" id="mobile" placeholder="Mobile #" required />
                </div>
                <div className="col-md-8" />
                <div className="col-md-2">
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-sm btn-light-theme rounded-3" onClick={handleSearch}><i className="fas fa-search me-2"></i> Search</button>
                    <button type="reset" className="btn btn-sm btn-light-danger rounded-3" onClick={handleReset}><i className="fas fa-times me-2"></i> Clear</button>
                  </div>
                </div>
              </div>
            </div>
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "14%" }} className="align-middle">Name</th>
                  <th scope="col" style={{ width: "14%" }} className="align-middle">Mobile #</th>
                  <th scope="col" style={{ width: "26%" }} className="align-middle">Address</th>
                  <th scope="col" style={{ width: "12%" }} className="align-middle">Last Order</th>
                  <th scope="col" style={{ width: "12%" }} className="align-middle">Tags</th>
                  <th scope="col" style={{ width: "12%" }} className="align-middle">Zone</th>
                  <th scope="col" style={{ width: "10%" }} className="align-middle text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {customers.map((row, index) => {
                  return (
                    <tr key={row.id.toString()}>
                      <td className="align-middle">{row.name || "Customer"}</td>
                      <td className="align-middle">{row.mobile}</td>
                      <td className="align-middle">{row.address}</td>
                      <td className="align-middle">{row.last_order && moment(row.last_order).format("Do MMM")}</td>
                      <td className="align-middle">{row.tags}</td>
                      <td className="align-middle">{row.zone ? row.zone.name : 'N/A'}</td>
                      <td className="align-middle">
                        <div className="d-flex gap-2 justify-content-center">
                          {permissions["UPDATE_CUSTOMER"] && <Link to={`/dashboard/customer?id=${row.id}`}><i className="far fa-edit"></i></Link>}
                          {permissions["DELETE_CUSTOMER"] && <a className="text-danger" onClick={() => handleDelete(row.id)}><i className="far fa-trash-alt"></i></a>}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <nav aria-label="pagination">
            <Pagination
              currentPage={active}
              totalCount={count}
              pageSize={filters.limit}
              offset={filters.offset}
              siblingCount={3}
              onPageChange={handlePageChange}
            />
          </nav>
        </div>
      </main>
    </Layout>
  )
}

export default Customers
